import * as Sentry from '@sentry/react';
import moment from 'moment';
import 'moment/locale/es';

/* eslint-disable no-useless-escape */
export const validateEmail = (email) => !!email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

export const sentryInit = () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    tracesSampleRate: 1.0, // lower the value in production
  });
};

/**
 * @param {*} feedBack - FeedBack object with name, event_id, email, comments and score
 * @param {*} callBack - function to return response
 */
export const submitUserFeedback = (feedBack, callBack) => {
  const organizationSlug = process.env.REACT_APP_SENTRY_ORGANIZATION_SLUG;
  const projectSlug = process.env.REACT_APP_SENTRY_PROJECT_SLUG;
  const DSN = process.env.REACT_APP_SENTRY_DSN;
  const feedBackURL = `https://sentry.io/api/0/projects/${organizationSlug}/${projectSlug}/user-feedback/`;

  const headers = {
    Authorization: `DSN ${DSN}`,
    'Content-Type': 'application/json',
  };

  fetch(feedBackURL, {
    method: 'POST',
    headers,
    body: JSON.stringify(feedBack),
  }).then((response) => callBack(response)).catch(() => callBack(false));
};

export const getPercentForFraction = (value) => Math.round(Number(value) * 1000) / 10;
export const roundToNearestPercent = (value) => Math.round(Number(value));

export function setMomentLocale(lang) {
  const browserLang = navigator.language;
  return moment.locale(lang === 'system' ? browserLang : lang);
}
